module.exports = __webpack_public_path__ + "img/icon-arrow-right.c5f5a799.svg";